// перевести копейи в рубли
export default function pennyToRubles(value) {
  return value / 100;
}
